import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import type { CreateAdminRequest } from '../types/admin.types';

const { Option } = Select;

interface CreateAdminModalProps {
    open: boolean;
    loading: boolean;
    roles: any[];
    loadingRoles: boolean;
    onCancel: () => void;
    onSubmit: (values: CreateAdminRequest) => void;
}

export const CreateAdminModal: React.FC<CreateAdminModalProps> = ({
    open,
    loading,
    roles,
    loadingRoles,
    onCancel,
    onSubmit
}) => {
    const [form] = Form.useForm();

    const handleCancel = () => {
        form.resetFields();
        onCancel();
    };

    const handleOk = () => {
        form.submit();
    };

    return (
        <Modal
            title="Create New Admin"
            open={open}
            onCancel={handleCancel}
            onOk={handleOk}
            confirmLoading={loading}
        >
            <Form form={form} layout="vertical" onFinish={onSubmit}>
                <Form.Item name="name" label="Name" rules={[{ required: false }]}>
                    <Input placeholder="Admin Name (Optional)" />
                </Form.Item>
                <Form.Item name="email" label="Email" rules={[{ required: true, type: 'email' }]}>
                    <Input />
                </Form.Item>
                <Form.Item
                    name="role_id"
                    label="Role"
                    rules={[{ required: true, message: 'Please select a role' }]}
                >
                    <Select loading={loadingRoles} placeholder="Select role">
                        {(roles || []).map((r: any) => (
                            <Option key={r.id} value={r.id}>
                                {r.display_name} ({r.name})
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </Form>
        </Modal>
    );
};
